import { faTrashCan } from '@fortawesome/pro-regular-svg-icons/faTrashCan';
import { faCircleStar } from '@fortawesome/pro-solid-svg-icons/faCircleStar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import Loader from './Loader';
import styles from './SelectedMembership.module.css';

export interface SelectedMembershipProps {
    name: string;
    saving?: boolean;
    onDelete?: () => void;
    className?: string;
}

export const SelectedMembership: FunctionComponent<SelectedMembershipProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={clsx(styles.left, styles.ellipsis)}>
                <FontAwesomeIcon
                    icon={faCircleStar}
                    color="#EAB464"
                    className={styles.starIcon}
                />
                <span className={clsx(styles.name, styles.ellipsis)}>{props.name}</span>
            </div>
            <div
                className={styles.right}
                onClick={() => !props.saving && props.onDelete && props.onDelete()}
            >
                {props.saving ? (
                    <Loader
                        color="black"
                        size={5}
                        loading={props.saving}
                        className={styles.loader}
                    />
                ) : (
                    <FontAwesomeIcon icon={faTrashCan} />
                )}
            </div>
        </div>
    );
};

export default SelectedMembership;
